<template>
  <div class="Index">
    <div class="l-container">
      <h1 class="m-label btn">AP月間集計
        <span class="h1-span" v-if="this.office === 'sendai'">仙台</span>
        <span class="h1-span" v-if="this.office === 'sapporo'">札幌</span>
        <span class="h1-span" v-if="this.office === 'nagoya'">名古屋</span>
        <span class="h1-span" v-if="this.office === 'fukuoka'">福岡</span>
        <span class="h1-span" v-if="this.office === 'shinjuku'">新宿</span>
        <span class="h1-span" v-if="this.office === 'oomiya'">大宮</span>
        <span class="h1-span" v-if="this.office === 'takamatsu'">高松</span>
        <span class="h1-span" v-if="this.office === 'takasaki'">高崎</span>
        <span class="h1-span" v-if="this.office === 'tokyo'">東京</span>
      </h1>
      <div class="wrapper">

        <div class="list-box">
          <table-c>
            <tr-c slot="tr-th">
              <th-c class="red">AP問合わせ日</th-c>
              <td-c><input v-model="search.contact_date[0]" type="text" @keyup="searchTable()" placeholder="2019-06"></td-c>
              <td-c><input v-model="search.contact_date[1]" type="text" @keyup="searchTable()" placeholder="※ここを入力した場合は期間検索になります"></td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c class="blue">AP問合わせ日2</th-c>
              <td-c><input v-model="search2.contact_date[0]" type="text" @keyup="searchTable2()" placeholder="2019-06"></td-c>
              <td-c><input v-model="search2.contact_date[1]" type="text" @keyup="searchTable2()" placeholder="※ここを入力した場合は期間検索になります"></td-c>
            </tr-c>
          </table-c>
        </div>

        <div>
          <bar-chart
            v-if="loaded"
            :styles="myStyles"
            :chart-data="datacollection"
            :options="options"
            :chart-text="chartText"
          ></bar-chart>

          <button @click="toggleType()">グラフタイプ</button>
          <!-- <button @click="toggleStacked()">Stacked</button> -->
          <button @click="toggleHidden()">グラフ表示</button>
          <button @click="toggleCartText()">件数表示</button>
          <button @click="toggleOffice('sendai')" v-bind:class="{ 'active': this.office === 'sendai'}">仙台</button>
          <button @click="toggleOffice('sapporo')" v-bind:class="{ 'active': this.office === 'sapporo'}">札幌</button>
          <button @click="toggleOffice('nagoya')" v-bind:class="{ 'active': this.office === 'nagoya'}">名古屋</button>
          <button @click="toggleOffice('fukuoka')" v-bind:class="{ 'active': this.office === 'fukuoka'}">福岡</button>
          <button @click="toggleOffice('shinjuku')" v-bind:class="{ 'active': this.office === 'shinjuku'}">新宿</button>
          <button @click="toggleOffice('oomiya')" v-bind:class="{ 'active': this.office === 'oomiya'}">大宮</button>
          <button @click="toggleOffice('takamatsu')" v-bind:class="{ 'active': this.office === 'takamatsu'}">高松</button>
          <button @click="toggleOffice('takasaki')" v-bind:class="{ 'active': this.office === 'takasaki'}">高崎</button>
          <button @click="toggleOffice('tokyo')" v-bind:class="{ 'active': this.office === 'tokyo'}">東京</button>
          <!-- <button dark color="indigo" @click="toggleSmooth(this)">Smooth</button> -->
          <!-- <v&#45;btn dark color="indigo" @click="fillData()">Randomize</v&#45;btn> -->
          <!-- <v&#45;btn @click="increase()">Increase height</v&#45;btn> -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
const url = getAPIURL() + '/api/v1/aggregate_appointments_month'

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  // offset: config.LIMIT,
  // max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'aggregate_appointments_month',
  pageNames: 'aggregate_appointments_months'
}

import BarChart from '@/components/util/BarChartB.vue'

export default {
  components: {
    BarChart
  },

  data () {
    return {
      datacollection: {},
      options: {},
      loaded: false,

      type: 'bar',
      stacked: false,
      hidden: false,
      showAllTooltips: true,
      display: false,
      height: 98,
      office: 'sendai',
      chartText: true,

      search: {
        contact_date: []
      },

      search2: {
        contact_date: []
      }
    }
  },

  computed: {
    aggregate_appointment_month () {
      return this.$store.getters.aggregate_appointment_month
    },

    aggregate_appointment_month_comparison () {
      return this.$store.getters.aggregate_appointment_month_comparison
    },

    myStyles () {
      return {
        height: `calc(${this.height}vh - 200px`,
        position: 'relative'
      }
    }
  },

  // mounted () {
  //   this.fillData()
  // },

  mounted () {
    this.loaded = false
    // try {
    //   const { userlist } = await fetch('/api/v1/aggregate_appointments_month')
    //   console.log('api')
    //   this.chartData = userlist
    //   this.loaded = true
    // } catch (e) {
    //   console.error(e)
    // }
  },

  methods: {
    increase () {
      this.height += 10
    },

    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },

    toggleType () {
      this.type === 'line' ? this.type = 'bar' : this.type = 'line'
      this.searchTable()
    },

    toggleStacked () {
      // this.stacked === false ? this.stacked = true : this.stacked = false
      this.stacked = !this.stacked
      this.searchTable()
    },

    toggleHidden () {
      // this.hidden === false ? this.hidden = true : this.hidden = false
      this.hidden = !this.hidden
      this.chartText = !this.chartText
      this.searchTable()
    },

    toggleCartText () {
      this.chartText = !this.chartText
      this.searchTable()
    },

    toggleSmooth (btn) {
      console.log(btn)
      // this.datacollection.datasets.lineTension = 5
    },

    toggleOffice (val) {
      this.office = val
      this.searchTable()
    },

    fillData () {
      this.datacollection = {
        labels: [...Array(31)].map((item, i) => {
          return i + 1
        }),
        datasets: [
          {
            type: this.type,
            lineTension: 0,
            label: '合計',
            hidden: this.hidden,
            // borderWidth: 1,
            borderColor: this.type === 'line' ? 'rgba(252, 121, 118, 1)' : 'rgba(252, 121, 118, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(252, 121, 118, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month.month[this.office][String(i + 1)].sum
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'DM',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(252, 121, 118, 1)' : 'rgba(252, 121, 118, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(252, 121, 118, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month.month[this.office][String(i + 1)].dm
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: '貼紙',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(252, 121, 118, 1)' : 'rgba(252, 121, 118, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(252, 121, 118, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month.month[this.office][String(i + 1)].harigami
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'HP',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(252, 121, 118, 1)' : 'rgba(252, 121, 118, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(252, 121, 118, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month.month[this.office][String(i + 1)].hp
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: '紹介',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(252, 121, 118, 1)' : 'rgba(252, 121, 118, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(252, 121, 118, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month.month[this.office][String(i + 1)].shokai
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'TEL',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(252, 121, 118, 1)' : 'rgba(252, 121, 118, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(252, 121, 118, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month.month[this.office][String(i + 1)].tel
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'MAIL',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(252, 121, 118, 1)' : 'rgba(252, 121, 118, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(252, 121, 118, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month.month[this.office][String(i + 1)].mail
              } else {
                return 0
              }
            })
          },

          {
            type: this.type,
            lineTension: 0,
            label: '合計2',
            hidden: this.hidden,
            // borderWidth: 1,
            borderColor: this.type === 'line' ? 'rgba(33, 150, 243, 1)' : 'rgba(33, 150, 243, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(33, 150, 243, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month_comparison.month[this.office][String(i + 1)].sum
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'DM2',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(33, 150, 243, 1)' : 'rgba(33, 150, 243, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(33, 150, 243, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month_comparison.month[this.office][String(i + 1)].dm
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: '貼紙2',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(33, 150, 243, 1)' : 'rgba(33, 150, 243, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(33, 150, 243, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month_comparison.month[this.office][String(i + 1)].harigami
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'HP2',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(33, 150, 243, 1)' : 'rgba(33, 150, 243, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(33, 150, 243, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month_comparison.month[this.office][String(i + 1)].hp
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: '紹介2',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(33, 150, 243, 1)' : 'rgba(33, 150, 243, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(33, 150, 243, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month_comparison.month[this.office][String(i + 1)].shokai
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'TEL',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(33, 150, 243, 1)' : 'rgba(33, 150, 243, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(33, 150, 243, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month_comparison.month[this.office][String(i + 1)].tel
              } else {
                return 0
              }
            })
          },
          {
            type: this.type,
            lineTension: 0,
            label: 'MAIL',
            hidden: true,
            borderColor: this.type === 'line' ? 'rgba(33, 150, 243, 1)' : 'rgba(33, 150, 243, 1)',
            backgroundColor: this.type === 'line' ? 'rgba(0, 0, 0, 0)' : 'rgba(33, 150, 243, 1)',
            data: [...Array(31)].map((item, i) => {
              if (this.aggregate_appointment_month.month) {
                return this.aggregate_appointment_month_comparison.month[this.office][String(i + 1)].mail
              } else {
                return 0
              }
            })
          }
        ]
      }
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,
        title: {
          display: false,
          text: 'HelloWorld!!'
        },
        legend: {
          display: true
        },
        animation: {
          // duration: 1000,
          // easing: 'easeOutBounce'
        },
        scales: {
          xAxes: [{
            ticks: {
              min: 0,
              // max: 10000000,
              // stepSize: 5000000,
              // fontSize: 11,
              callback: (label, index, labels) => {
                return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 日'
              }
            },
            // stacked: false
            stacked: this.stacked
          }],
          yAxes: [{
            ticks: {
              // fontSize: 11
            },
            // stacked: false // lineの時は積み重ねない為false
            // stacked: this.type !== 'line'
            // stacked: this.stacked !== false
            stacked: this.stacked
          }]
        }
      }
    },

    searchTable (e) {
      let that = this
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // aggregate
        var paramsList = [
          'contact_date'
        ]
        paramsList.forEach((e) => {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else {
            params[e] = [search[e][0]]
          }
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then((response) => {
          that.loaded = true
          // success callback
          console.log(response)
          store.state.item.aggregate_appointment_month = response.data
          that.fillData()
        }, (response) => {
          // error callback
          console.log('error')
        })
      }
      searchTable()
    },

    searchTable2 (e) {
      let that = this
      let search = this.search2
      var store = this.$store
      var params = {}
      function searchTable () {
        // aggregate
        var paramsList = [
          'contact_date'
        ]
        paramsList.forEach((e) => {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else {
            params[e] = [search[e][0]]
          }
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then((response) => {
          // success callback
          console.log(response)
          store.state.item.aggregate_appointment_month_comparison = response.data
          that.fillData()
        }, (response) => {
          // error callback
        })
      }
      searchTable()
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      const year = new Date().getFullYear()
      const month = ('0' + (new Date().getMonth() + 1)).slice(-2)
      vm.search.contact_date.push(year + '-' + month)

      const year2 = new Date().getFullYear() - 1
      const month2 = ('0' + (new Date().getMonth() + 1)).slice(-2)
      vm.search2.contact_date.push(year2 + '-' + month2)

      vm.searchTable()
      vm.searchTable2()

      // setTimeout(() => {
      //   vm.searchTable()
      //   vm.searchTable2()
      // }, 0)
    })
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin: 0;
}

.table {
  margin-top: 0 !important;
}

.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}

.th {
  cursor: pointer;
}

input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}

.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
  outline: none;
}

.h1-span {
  color: #41b883;
}

.red {
  position: relative;
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: -1px;
    right: -3px;
    background: #fc7975;
    height: 27px;
    width: 5px;
  }
}

.blue {
  position: relative;
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: -1px;
    right: -3px;
    background: #2395f3;
    height: 27px;
    width: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// AggregatesAppointmentsMonth.vue?35d9a72e